module.exports = __webpack_public_path__ + "fonts/lato-regular.2d36b1a9.ttf";